export default "__VITE_ASSET__BMZhtyX$__"